import './style.scss';
import { FC } from 'react';
import countryCodes from '../../assets/data/CountryCodes.json';

type NationalityBadgeProps = {
  nationality?: string;
};

const NationalityBadge: FC<NationalityBadgeProps> = ({ nationality }) => {
  // Cherche le pays correspondant à la nationalité (codeCountry)
  const country = nationality
    ? countryCodes.find(
        (c: any) => c.codeCountry.toLowerCase() === nationality.toLowerCase()
      )
    : undefined;

  // Si trouvé, on utilise le code pour l'image et codeCountry pour le texte, sinon FR/FRA
  const codeImg = country ? country.code : 'FR';
  const codeCountry = country ? country.codeCountry : 'FRA';

  return (
    <div className="NationalityBadge">
      <img
        src={`${process.env.PUBLIC_URL}/img/flags/${codeImg.toLowerCase()}.png`}
        alt={`drapeau ${codeCountry}`}
        className="flag"
      />
      {codeCountry}
    </div>
  );
};

export default NationalityBadge;
